module.exports = __webpack_public_path__ + "fonts/Veneer.5b79b36c.eot";